import darken from 'polished/lib/color/darken';
import { colors } from './colors.js';

const boxShadows = {
  default: '0 1px 3px 0 rgba(0,0,0,0.2)',
  focus: "0 0 0 2px ".concat(darken(0.2, colors.primary.main)),
  active: '0 1px 4px 0 rgba(0,0,0,.33)',
  selected: 'inset 0 0 4px 0 rgba(0,0,0,0.2)',
  subtle: '0 1px 1px 0 rgba(0,0,0,0.1)'
};
const boxShadowsDark = {
  ...boxShadows,
  focus: "0 0 0 2px ".concat(colors.primary.light),
  subtle: '0 1px 1px 0 rgba(255,255,255,0.1)'
};

export { boxShadows, boxShadowsDark };
